import { GET } from "./CRUDService";

const DownloadFile = async (
  downloadZipUrl,
  transaction_id,
  bulk_download,
  showMessageModal
) => {
  const urlWithParams = `${downloadZipUrl}${transaction_id}`;

  try {
    const response = await GET(urlWithParams);

    if (!response.ok) {
      console.error("Error fetching response:", response.statusText);
      showMessageModal(
        false,
        "Download Failed",
        "Failed to fetch data from the server."
      );
      return;
    }

    // Check if it is a zip download
    if (bulk_download) {
      await handleZipDownloadResponse(
        response,
        transaction_id,
        showMessageModal
      );
    } else {
      await handleCredentialDownloadResponse(
        response,
        transaction_id,
        showMessageModal
      );
    }
  } catch (error) {
    console.error("Error downloading file:", error);
    showMessageModal(
      false,
      "Download Failed",
      "An error occurred while processing your request."
    );
  }
};

const handleZipDownloadResponse = async (
  response,
  transaction_id,
  showMessageModal
) => {
  try {
    const contentType = response.headers.get("content-type") || "";

    if (contentType.includes("application/json")) {
      const responseData = await response.json();
      const isSuccess = response.ok;

      if (responseData.message) {
        showMessageModal(isSuccess, responseData.status, responseData.message);
      } else if (responseData.download_url) {
        const filename = responseData.filename
          ? responseData.filename
          : (() => {
              const urlParts = responseData.download_url.split("/");
              const suggestedFilename =
                urlParts[urlParts.length - 1].split("?")[0];
              return suggestedFilename.endsWith(".zip")
                ? suggestedFilename
                : `${transaction_id}.zip`;
            })();

        await downloadFileFromUrl(
          responseData.download_url,
          filename,
          showMessageModal
        );
      } else if (responseData.error) {
        showMessageModal(false, "Download Failed", responseData.error);
      } else {
        showMessageModal(
          false,
          "Download Failed",
          "Unexpected response format."
        );
      }
    } else {
      await handleDirectFileDownload(
        response,
        transaction_id,
        showMessageModal
      );
    }
  } catch (error) {
    showMessageModal(
      false,
      "Download Failed",
      "Failed to process the download response."
    );
  }
};

const handleDirectFileDownload = async (
  response,
  transaction_id,
  showMessageModal
) => {
  if (response.ok) {
    const blob = await response.blob();
    const contentDisposition = response.headers.get("Content-Disposition");

    const filename = contentDisposition
      ? contentDisposition.match(/filename="(.+?)"/)?.[1]
      : `${transaction_id}`;

    const url = window.URL.createObjectURL(blob);
    await downloadBlob(url, filename);
  } else {
    showMessageModal(false, "Download Failed", "Failed to download the file.");
  }
};

const downloadFileFromUrl = async (fileUrl, filename, showMessageModal) => {
  try {
    const fileResponse = await fetch(fileUrl);

    if (!fileResponse.ok) {
      showMessageModal(
        false,
        "Download Failed",
        "Failed to fetch the ZIP file."
      );
      return;
    }

    const blob = await fileResponse.blob();

    const url = window.URL.createObjectURL(blob);
    await downloadBlob(url, filename);
  } catch (error) {
    showMessageModal(
      false,
      "Download Failed",
      "Failed to download the ZIP file."
    );
  }
};

const handleCredentialDownloadResponse = async (
  response,
  transaction_id,
  showMessageModal
) => {
  if (response.ok) {
    const blob = await response.blob();

    const contentDisposition = response.headers.get("Content-Disposition");

    const filename = contentDisposition
      ? contentDisposition.match(/filename="(.+?)"/)?.[1]
      : `${transaction_id}`;

    const url = window.URL.createObjectURL(blob);
    await downloadBlob(url, filename);
  } else {
    console.error("Error fetching the file:", response.statusText);
    showMessageModal(false, "Download Failed", "Failed to download the file.");
  }
};

const downloadBlob = (url, filename) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const downloadFromUrl = (fileUrl, filename) => {
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default DownloadFile;
